<template>
  <div class="sole-good" @click="goDetail">
    <div v-if="sku.currentSku" class="current-sku">当前商品</div>
    <good-image
      :img-url="sku.skuImg.imgUrl"
      :image-width="goodWidth"
      :stock-status="stockStatus"
      :promote-tag-pic="promoteTagPic"
      :sort-index="sortIndex"
      :type="'sole-good-remind'"
      :sku-img="skuImg"
    />
    <div class="info">
      <base-info
        :name="sku.skuBase.skuName"
        :sku-format="formatInfo"
        :custom-style="customStyle"
      />
      <good-price
        :ssu="sku"
        :ssu-info="ssuInfo"
        complex
        :from-page="fromPage"
        :show-original-price="showOriginalPrice"
        :custom-operator="customOperator"
        :show-discount-price="true"
        :is-hint="sku.promise.isHintNoArriveAm"
        @beforeAddGoods="beforeAddGoods"
        @goDetail="goDetail"
      />
      <div v-if="goodTags && goodTags.length" class="good-tag-wrap">
        <good-tag :good-tags="goodTags" />
      </div>
      <!-- 押金展示-->
      <div v-if="depositInfo" class="deposit-info">
        {{ depositInfo }}
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '../mixin'

export default {
  name: 'SoleGood',
  mixins: [mixin],
  data() {
    return {
      customOperator: {
        simple: false,
        showPromoteTip: true,
        type: 'normal'
      },
      customStyle: {
        name: {
          margin: 0
        }
      }
    }
  }
}
</script>

<style lang="scss">
.sole-good {
  position: relative;

  width: 100%;

  padding: 0.24rem 0.32rem 0;
  overflow: hidden;

  flex: none;
  box-sizing: border-box;
  @include flex(row, space-between, flex-start, nowrap);
  .current-sku {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    padding: 0.08rem 0.12rem;

    background-color: #02b352;
    border-radius: 0 0 4px 0;
    @include text(0.24rem, #fff);
  }
}
.info {
  position: relative;

  margin-left: 0.16rem;
  padding-bottom: 0.24rem;
  overflow: hidden;

  flex: auto;
  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: scale(0.5, 0.5);

    width: 200%;
    height: 1px;

    background-color: #f5f5f5;

    content: '';
    box-sizing: border-box;
    transform-origin: 0 0;
  }
  .deposit-info {
    height: 0.36rem;
    margin-top: 0.16rem;

    font-size: 0.2rem;
    line-height: 0.36rem;
    text-align: left;
    color: #8c8c8c;
  }
}
</style>
